import { render, staticRenderFns } from "./ModalFormGroupPublication.vue?vue&type=template&id=5a549d12&scoped=true&"
import script from "./ModalFormGroupPublication.vue?vue&type=script&lang=js&"
export * from "./ModalFormGroupPublication.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormGroupPublication.vue?vue&type=style&index=0&id=5a549d12&prod&scoped=true&lang=css&"
import style1 from "./ModalFormGroupPublication.vue?vue&type=style&index=1&id=5a549d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a549d12",
  null
  
)

export default component.exports